import { GOOGLE_ANALYTICS_MEASUREMENT_ID } from 'core/api'
import { getPartnerId, getPartnerListOfGaPurchaseEventDisabled } from 'core/singleton'
import { GA_EVENT, BROADCAST_STATE_CODE, GA_BROADCAST_TYPE_CODE } from './enums'
import { getExecutorForPartner } from 'core/util/partner'

export class GAHelper {
  init(partnerId?: string, location?: string) {
    try {
      // 롯데 면세점 ga 관련 에러로 인해 백화현상 발생함으로 예외처리 [2023. 07. 28]
      if (['ldfs'].includes(partnerId || '') || getExecutorForPartner(partnerId)?.isGADisabled) {
        return
      }
      if (!window.gtag) return
      window.gtag('config', GOOGLE_ANALYTICS_MEASUREMENT_ID, {
        send_page_view: false,
      })
    } catch (e) {
      console.error('gtag init error')
    }
  }

  sendEvent(event: GA_EVENT, additionalPayload?: GAAdditionalPayload) {
    try {
      // 롯데 면세점 ga 관련 에러로 인해 백화현상 발생함으로 예외처리 [2023. 07. 28]
      if (
        ['ldfs'].includes(getPartnerId()) ||
        getExecutorForPartner(getPartnerId())?.isGADisabled
      ) {
        return
      }
      if (!event || !window.gtag) return
      if (
        event === GA_EVENT.CLICK_PURCHASE &&
        (additionalPayload as GADefault)?.partnersId &&
        getPartnerListOfGaPurchaseEventDisabled().includes(
          (additionalPayload as GADefault).partnersId as string,
        )
      )
        return
      window.gtag('event', event, {
        ...additionalPayload,
      })
    } catch (e) {
      console.error('gtag event error')
    }
  }

  convertBroadcastStateCodeToBroadcastTypeCode(broadcastStateCode?: BroadcastStateCode) {
    switch (broadcastStateCode) {
      case BROADCAST_STATE_CODE.ACCEPTED:
      case BROADCAST_STATE_CODE.READY:
      case BROADCAST_STATE_CODE.STAND_BY:
        return GA_BROADCAST_TYPE_CODE.READY
      case BROADCAST_STATE_CODE.CONVERTING:
      case BROADCAST_STATE_CODE.ON_AIR:
      case BROADCAST_STATE_CODE.WARNING:
        return GA_BROADCAST_TYPE_CODE.LIVE
      case BROADCAST_STATE_CODE.VOD:
        return GA_BROADCAST_TYPE_CODE.VOD
      default:
        return ''
    }
  }
}

export type GAAdditionalPayload = GADefault | GAProductItem

export type GADefault = {
  partnersId?: string
  location?: string
  number_of_item?: string
  banner_type?: string
  broadcastTypeCode?: string
  broadcastName?: string
  currency?: string
  value?: number
  language?: string
  pageLocation?: string
  pageReferrer?: string
  pageTitle?: string
  screenResolution?: string
  affiliation?: string
  items?: GAProductItem[]
  position?: string
  keyword?: string
}

export interface GAProductItem {
  discount: string
  item_brand: string
  item_id: string
  item_name: string
  price: string
}
